import {
  pgTable,
  uuid,
  text,
  integer,
  jsonb,
  timestamp,
  index,
} from "drizzle-orm/pg-core";

/** Per-locale blog copy stored inside the `translations` JSONB column. */
export type BlogPostLocale = {
  title?: string;
  excerpt?: string;
  contentHtml?: string;
  metaTitle?: string;
  metaDescription?: string;
  /** Per-locale URL slug; falls back to the top-level slug column when empty. */
  slug?: string;
};

export type BlogPostTranslations = {
  lv?: BlogPostLocale;
  en?: BlogPostLocale;
  ru?: BlogPostLocale;
};

export const blogPosts = pgTable(
  "blog_posts",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    slug: text("slug").notNull().unique(),
    // DB-backed translations — one object per locale ({ lv, en, ru }).
    translations: jsonb("translations")
      .notNull()
      .default({})
      .$type<BlogPostTranslations>(),
    coverImageUrl: text("cover_image_url"),
    status: text("status").notNull().default("draft"),
    publishedAt: timestamp("published_at", { withTimezone: true }),
    position: integer("position").notNull().default(0),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    statusPublishedIdx: index("idx_blog_posts_status_published_at").on(
      t.status,
      t.publishedAt
    ),
  })
);

export type BlogPost = typeof blogPosts.$inferSelect;
export type NewBlogPost = typeof blogPosts.$inferInsert;
